
import { 
    ADD_USER,
    ADD_USER_SUCCESS,
    ADD_USER_FAIL, 
    ADD_USER_RESET,
} from "../actions/addUserAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const addUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_USER:
            return {
                ...state,
                apiState: "loading",
            };
        case ADD_USER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case ADD_USER_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case ADD_USER_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default addUserReducer;
